import {
  SET_TASK_GROUP,
} from './mutation-types'
import api from '@/api'

const state = {
  groups: [],
}

const mutations = {
  [SET_TASK_GROUP] (state, payload) {
    state.groups = payload
  },
}

const actions = {
  // 放弃
  async abandonAnalyse ({commit, state}, payload) {
    let param = {
      taskIds: payload.taskIds,
    }
    const {result, message, code} = await api.taskApi.abandonAnalyse(param)
    return {result, message, code}
  },
  // 预处理停止
  async stopPreTask ({commit, state}, payload) {
    let param = {
      taskIds: payload.taskIds,
    }
    const {result, message, code} = await api.taskApi.stopPreTask(param)
    return {result, message, code}
  },
  // 自动重提（运行中渲染作业）
  async updateAutoRestartLimit({state}, payload) {
    const params = {
      ...payload,
    }
    const res = await api.taskApi.updateAutoRestartLimit(params)
    return res
  },
  // 重提(渲染作业)
  async recommitTask ({state}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.taskApi.recommitTask(param)
    return {result, message, code}
  },
  // 重提(分析作业)
  async restartTask ({state}, payload) {
    let param = {
      ...payload,
    }
    const data = await api.taskApi.restartTask(param)
    return data
  },
  // 重提(预处理作业)
  async recommitPreTask ({state}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code, data} = await api.taskApi.recommitPreTask(param)
    return {result, message, code, data}
  },
  // 获取共同的属性或要求
  async getTaskCommonValue ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.taskApi.getTaskCommonValue(param)
    return data
  },
   // 增加属性，渲染
  async renderingAddProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingAddProperties(param)
    return {result, message, code}
  },
   // 增加属性，预处理
  async preAddProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preAddProperties(param)
    return {result, message, code}
  },
  // 增加属性，分析
  async analyseAddProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseAddProperties(param)
    return {result, message, code}
  },
  // 删除属性，分析
  async analyseDeleteProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseDeleteProperties(param)
    return {result, message, code}
  },
  // 删除属性，预处理
  async preDeleteProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preDeleteProperties(param)
    return {result, message, code}
  },
  // 删除属性，渲染
  async renderingDeleteProperties ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingDeleteProperties(param)
    return {result, message, code}
  },
  // 增加要求，分析
  async analyseAddRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseAddRequirements(param)
    return {result, message, code}
  },
  // 增加要求，预处理
  async preAddRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preAddRequirements(param)
    return {result, message, code}
  },
  // 增加要求，渲染
  async renderingAddRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingAddRequirements(param)
    return {result, message, code}
  },
  // 删除要求，渲染
  async renderingDeleteRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingDeleteRequirements(param)
    return {result, message, code}
  },
  // 删除要求，预处理
  async preDeleteRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preDeleteRequirements(param)
    return {result, message, code}
  },
  // 删除要求，分析
  async analyseDeleteRequirements ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseDeleteRequirements(param)
    return {result, message, code}
  },

   // 增加群组，分析
  async analyseAddCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseAddCategory(param)
    return {result, message, code}
  },
  // 增加群组，预处理
  async preAddCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preAddCategory(param)
    return {result, message, code}
  },
  // 增加群组， 渲染
  async renderingAddCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingAddCategory(param)
    return {result, message, code}
  },

   // 删除群组，分析
  async analyseDeleteCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseDeleteCategory(param)
    return {result, message, code}
  },
  // 删除群组，预处理
  async preDeleteCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preDeleteCategory(param)
    return {result, message, code}
  },
  // 删除群组， 渲染
  async renderingDeleteCategory ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingDeleteCategory(param)
    return {result, message, code}
  },

  // 增加约束，分析
  async analyseAddConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseAddConstraints(param)
    return {result, message, code}
  },
  // 增加约束，预处理
  async preAddConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preAddConstraints(param)
    return {result, message, code}
  },
  // 增加约束，渲染
  async renderingAddConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingAddConstraints(param)
    return {result, message, code}
  },
  // 删除约束 分析
  async analyseDeleteConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.analyseDeleteConstraints(param)
    return {result, message, code}
  },
   // 删除约束 预处理
  async preDeleteConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.preDeleteConstraints(param)
    return {result, message, code}
  },
   // 删除约束 渲染
  async renderingDeleteConstraints ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.renderingDeleteConstraints(param)
    return {result, message, code}
  },
  // 获取属性要求约束群组（单个任务）
  // 分析
  async analyseGetSingleStrategyForDataBase ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.taskApi.analyseGetSingleStrategyForDataBase(param)
    return data
  },
   // 获取属性要求约束群组（单个任务）
  // 预处理
  async preGetSingleStrategyForDataBase ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.taskApi.preGetSingleStrategyForDataBase(param)
    return data
  },
  // 获取属性要求约束群组（单个任务）
  // 渲染
  async renderingGetSingleStrategyForDataBase ({state}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.taskApi.renderingGetSingleStrategyForDataBase(param)
    return data
  },
   // 获取频率调度
  async getFrequencyControl ({state}, payload) {
    let param = {
      ...payload,
    }

    const {data} = await api.taskApi.getFrequencyControl(param)
    return data
  },
     // 设置频率调度
  async setFrequencyControl ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.setFrequencyControl(param)
    return {result, message, code}
  },
  // 批量修改频率调度
  async updateFrequency ({state}, payload) {
    let param = {
      ...payload.query,
    }
    const {result, message, code} = await api.taskApi.updateFrequency(param)
    return {result, message, code}
  },
  // 单个重置群组
  async resetSingleTaskValue ({state, dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.taskApi.resetSingleTaskValue(param)
    return {result, message, code}
  },
  // 查询所有群组
  async queryCategory ({commit, state}) {
    if (state.groups.length > 0) return false
    const {data} = await api.taskApi.queryCategory({})
    commit(SET_TASK_GROUP, data)
  },
  // 删除渲染作业
  async deleteAnalysisTask ({state}, payload) {
    const data = await api.taskApi.deleteAnalysisTask(payload)
    return data
  },
  // 恢复分析作业
  async regainAnalyseTask ({state}, payload) {
    const data = await api.taskApi.regainAnalyseTask(payload)
    return data
  },
  // 分析设置超时停止时间
  async analysisSetTaskOverTimeStop ({state}, payload) {
    const data = await api.taskApi.analysisSetTaskOverTimeStop(payload)
    return data
  },
  // 预处理设置超时停止时间
  async preSetTaskOverTimeStop ({state}, payload) {
    const data = await api.taskApi.preSetTaskOverTimeStop(payload)
    return data
  },
  // 渲染设置超时停止时间
  async setTaskOverTimeStop ({state}, payload) {
    const data = await api.taskApi.setTaskOverTimeStop(payload)
    return data
  },
  // 手动卡帧上报
  async frameReporting({state}, payload) {
    const params = {
      ...payload,
    }
    const res = await api.taskApi.frameReporting(params)
    return res
  },
  // 修改工单号
  async setOrderNo ({state}, payload) {
    const params = {
      ...payload,
    }
    const res = await api.taskApi.setOrderNo(params)
    return res
  },
  // 标记卡帧
  async setTaskAbnormalSetting ({state}, payload) {
    const data = await api.taskApi.setTaskAbnormalSetting(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
